"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cart = require("@bento-core/cart");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var TextFieldView = function TextFieldView(_ref) {
  var clsName = _ref.clsName,
    placeholder = _ref.placeholder;
  var _ref2 = (0, _react.useState)(''),
    _ref3 = _slicedToArray(_ref2, 2),
    text = _ref3[0],
    setText = _ref3[1];
  var cartContext = (0, _react.useContext)(_cart.CartContext);
  var context = cartContext.context;
  var dispatch = context.dispatch;
  (0, _react.useEffect)(function () {
    dispatch((0, _cart.onCommentChange)(text));
  }, [text]);
  return /*#__PURE__*/_react.default.createElement("textarea", {
    onChange: function onChange(e) {
      setText("".concat(e.target.value));
    },
    className: clsName,
    placeholder: placeholder,
    id: "multiline-user-coments"
  });
};
var _default = TextFieldView;
exports.default = _default;